import React from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const styles = theme => ({
  root: {
    display: "flex"
  },
  formControl: {
    margin: theme.spacing.unit * 3
  },
  checkboxRoot: {
    padding: "3px"
  },
  labelRoot : {
    fontSize : "16px",
  }
});

class CheckboxesGroup extends React.Component {
  render() {
    const {
      classes,
      items,
      onCheckboxChanged,
      categoryName,
      checkboxState
    } = this.props;

    return (
      <div className={classes.root}>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormGroup>
            {items.map(item => (
              <FormControlLabel
                className={classes.labelRoot}
                key={item.key}
                control={
                  <Checkbox
                    className={classes.checkboxRoot}
                    checked={checkboxState[item.key]}
                    onChange={onCheckboxChanged(categoryName, item.key)}
                    value={item.key}
                  />
                }
                label={item.label}
              />
            ))}
          </FormGroup>
        </FormControl>
      </div>
    );
  }
}

export default withStyles(styles)(CheckboxesGroup);
